import React from 'react'
import './sectionSplitWrapper.scss'

const SectionSplitWrapper = ({ className = '', children }) => {
	return <div className={`section_splitWrapper ${className}`}>{children}</div>
}

export default SectionSplitWrapper
